import localforage from 'localforage';
import Transaction from "../models/Transaction.jsx";
import SiteUrlStorage from "./SiteUrlStorage.js";

export default class TransactionStorage {
	static storage = null;
	static lastPromise = Promise.resolve();

	static _setup() {
		SiteUrlStorage.store();
		if(TransactionStorage.storage) {
			return TransactionStorage.storage;
		}
		return TransactionStorage.storage = localforage.createInstance({
			storeName: 'offlineTransactions'
		});
	}

	static clear() {
		const storage = TransactionStorage._setup();
		return TransactionStorage.lastPromise = TransactionStorage.lastPromise.then(() => {
			return storage.clear();
		});
	}

	static setItem(key, value) {
		const storage = TransactionStorage._setup();
		return TransactionStorage.lastPromise = TransactionStorage.lastPromise.then(() => {
			return storage.setItem(key, value)
				.then((result) => {
					return result;
				});
		});
	}

	static removeItem(key) {
		const storage = TransactionStorage._setup();
		return TransactionStorage.lastPromise = TransactionStorage.lastPromise.then(() => {
			return storage.removeItem(key);
		});
	}

	static iterate(iterateCallback, successCallback) {
		const storage = TransactionStorage._setup();
		return TransactionStorage.lastPromise = TransactionStorage.lastPromise.then(() => {
			return storage.iterate((transaction) => {
					transaction = Transaction.create(transaction);
					iterateCallback(transaction);
				})
				.then(() => {
					if(successCallback) {
						successCallback();
					}
				});

		});
	}
}